import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {FC} from "react";
import {ITableHeader} from "../CustomTableHelper";

interface Props {
    headCells: ITableHeader[]
}

const CustomTableHeader: FC<Props> = (props) => {
    return (
        <TableHead>
            <TableRow>
                {props.headCells.map((headCell, idx) => (
                    <TableCell
                        key={`cell-${idx}`}
                        padding='normal'
                        sx={{minWidth: headCell.min_width ?? "100%"}}
                    >
                        {headCell.label}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

export default CustomTableHeader